import React, { useState } from "react";
import { HttpService } from "../../apiAuthorization/httpService";

export const Streak = React.createContext(null);

export const StreakContext = props => {
    const [streak, setStreak] = useState([]);

    const getStreak = () => {
        HttpService.post("/Home/GetStreak")
        .then((result) => {
            if (result != null) {
                setStreak(result);
            }
        },
        (error) => {
            console.log(error);
        });
    }
    return (
        <>
            <Streak.Provider value={{ streak, getStreak }}>
                {props.children}
            </Streak.Provider>
        </>
    );
}
